module.exports = "<div class=\"footer\">\r\n  <div class=\"pull-right\">\r\n  </div>\r\n  <div>\r\n    <strong>Copyright</strong> {{ 'product-name' | translate }} &copy; 2017\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/footer/footer.template.html
// module id = ./src/app/components/common/footer/footer.template.html
// module chunks = main